import * as React from 'react';
import { useLearningPathByIdStore } from '../../store/learning-path-by-id-store';

const NumberOfLessons: React.FC = () => {
  const { lessons } = useLearningPathByIdStore();

  const numberOfLessons = lessons?.data?.length || 0;

  return <>{numberOfLessons ?? '-'}</>;
};

export { NumberOfLessons };
